import { ACTIVE_YEAR, FESTIVAL_DAYS } from "@flow/utils/constants";

const localizations: ILocalization = {
  "en-US": {
    strings: {
      hi: "Hi",
    },
    ticketsLinkLabel: "Tickets",
    artists: {
      artistListInCompleted: "More acts to be announced",
      newBadgeLabel: "New",
      tagFilterTitleLabel: "Filter by tag",
    },
    artist: {
      backButtonLabel: "Back to the full lineup",
      previousArtistButtonLabel: "",
      nextArtistButtonLabel: "",
    },
    food: {
      backButtonLabel: "Back to the restaurant list",
    },
    arts: {
      operaTitle: "Flow x Opera 7.–8.8.2019",
      festivalAreaTitle: `Art at Flow area ${FESTIVAL_DAYS}${ACTIVE_YEAR}`,
      flowArtsListInCompleted: "Flow's arts program will be announced later",
    },
    art: {
      backButtonLabel: "Back to the arts",
    },
    family: {
      backButtonLabel: "Back to the listing",
    },
    talk: {
      backButtonLabel: "Back to the talks",
    },
    news: {
      detail: {
        backButtonLabel: "",
      },
    },
    newsletterForm: {
      notValidEmail: "Please enter an email address",
      success: "We have sent you a confirmation email",
    },
    rightsReserved: "All rights reserved",
    cookiePolicyLinkLabel: "Cookie Policy",
    privacyPolicyLinkLabel: "Privacy Policy",
    404: {
      title: "Ooops!",
      text: "The page you were looking for was not found!",
      link: "To frontpage",
    },
    myFlow: {
      title: "My Flow",
      login: "Log In",
      logout: "Log Out",
      loginInstruction:
        "By logging in, you can save your schedule and sync My Flow for all your devices.",
      googleLogin: "Log in with Google",
      appleLogin: "Log in with Apple",
      fbLogin: "Login with Facebook",
      fbLogout: "Logout",
      fbLoginNotification: "Login with Facebook to save your schedule.",
      copyLink:
        "Copy a shareable direct link to your schedule: https://www.flowfestival.com/en/my-flow/?list={userId}",
      print: "Print schedule",
    },
    findUsAt: "Find us at",
  },

  "fi-FI": {
    strings: {
      hi: "Hei",
    },
    ticketsLinkLabel: "Liput",
    artists: {
      artistListInCompleted: "Lisää artistijulkistuksia tulossa",
      newBadgeLabel: "Uusi",
      tagFilterTitleLabel: "Suodata tunnisteen perusteella",
    },
    artist: {
      backButtonLabel: "Takaisin artisteihin",
      previousArtistButtonLabel: "",
      nextArtistButtonLabel: "",
    },
    food: {
      backButtonLabel: "Takaisin ravintolalistaan",
    },
    arts: {
      festivalAreaTitle: `Taide Flow-alueella ${FESTIVAL_DAYS}${ACTIVE_YEAR}`,
      operaTitle: "Flow x Ooppera 7.–8.8.2019",
      flowArtsListInCompleted: " Flow'n taideohjelma julkaistaan myöhemmin",
    },
    art: {
      backButtonLabel: "Takaisin taidelistaukseen",
    },
    family: {
      backButtonLabel: "Takaisin listaukseen",
    },
    talk: {
      backButtonLabel: "Takaisin",
    },
    news: {
      detail: {
        backButtonLabel: "",
      },
    },
    newsletterForm: {
      notValidEmail: "Ole hyvä ja tarkista sähköpostiosoitteesi",
      success: "Olemme lähettäneet sinulle varmistuksen sähköpostiisi",
    },
    rightsReserved: "Pidätämme oikeuden muutoksiin.",
    cookiePolicyLinkLabel: "Sivuston evästeet",
    privacyPolicyLinkLabel: "Tietosuojaseloste",
    404: {
      title: "Hupsista!",
      text: "Hakemaasi sivua ei valitettavasti löytynyt!",
      link: "Etusivulle",
    },
    myFlow: {
      title: "Oma Flow",
      login: "Kirjaudu sisään",
      logout: "Kirjaudu ulos",
      loginInstruction:
        "Kirjautumalla sisään voit tallentaa aikataulusi ja synkronoida My Flow’n eri laitteidesi välillä.",
      googleLogin: "Kirjaudu Googlella",
      appleLogin: "Kirjaudu Applella",
      fbLogin: "Kirjaudu Facebook-tunnuksilla",
      fbLogout: "Kirjaudu ulos",
      fbLoginNotification:
        "Kirjaudu Facebook-tunnuksillasi tallentaaksesi aikatulusi.",
      copyLink:
        "Kopioi jaettava URL aikatauluusi: https://www.flowfestival.com/my-flow/?list={userId}",
      print: "Tulosta ohjelma",
    },
    findUsAt: "Löydä meidät",
  },

  "ru-RU": {
    ticketsLinkLabel: "БИЛЕТЫ",
    artists: {
      artistListInCompleted: "Программа будет обновлена",
      newBadgeLabel: "New",
      tagFilterTitleLabel: "Filter by tag",
    },
    artist: {
      backButtonLabel: "к полному списку артистов",
      previousArtistButtonLabel: "",
      nextArtistButtonLabel: "",
    },
    food: {
      backButtonLabel: "Back to the restaurant list",
    },
    arts: {
      operaTitle: "Flow x Opera 7.–8.8.2019",
      festivalAreaTitle: `Art at Flow area ${FESTIVAL_DAYS}${ACTIVE_YEAR}`,
      flowArtsListInCompleted:
        "Художественная программа Flow будет объявлена позже",
    },
    art: {
      backButtonLabel: "Back to the arts",
    },
    family: {
      backButtonLabel: "Back to the listing",
    },
    news: {
      detail: {
        backButtonLabel: "",
      },
    },
    newsletterForm: {
      notValidEmail: "Please enter an email address",
      success: "We have sent you a confirmation email",
    },
    rightsReserved: "Все права защищены",
    cookiePolicyLinkLabel: "Политика использования cookies",
    privacyPolicyLinkLabel: "Политика использования cookies",
    404: {
      title: "Ooops!",
      text: "Страница, которую вы искали, не найдена!",
      link: "На главную",
    },
    myFlow: {
      title: "My Flow",
      fbLogin: "Login with Facebook",
      fbLogout: "Logout",
      fbLoginNotification: "Login with Facebook to save your schedule.",
      copyLink:
        "Copy a shareable direct link to your schedule: : https://www.flowfestival.com/en/my-flow/?list={userId}",
      print: "Print schedule",
    },
    findUsAt: "Присоединяйтесь",
  },
};

export default localizations;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/localization.ts